import z from "zod";

const translationPath =
  "chatBot.page.automations.automationRuleEncMessage.errors.";

const templateGeneralSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  {
    invalid_type_error: translationPath + "templateGeneral",
  },
);

const establishmentsSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const sendTypePasswordEmrResultSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const sendTypeEmrResultSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const ticketAutomationRuleEncMessageSectorsSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const ticketAutomationRuleEncMessagePrescriptionSectorsSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const ticketAutomationRuleEncMessageMedProcTypesSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const ticketAutomationRuleEncMessageEncounterTypesSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const ticketAutomationRuleEncMessageInProcClassificsSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const automationRuleEncMessageSchema = z
  .object({
    ticketAutomationRuleId: z.string().optional(),
    sendTypePasswordEmrResult: sendTypePasswordEmrResultSchema.nullish(),
    sendTypeEmrResult: sendTypeEmrResultSchema.nullish(),
    templateGeneral: templateGeneralSchema.nullable(),
    name: z.string().min(1, translationPath + "name"),
    initialDate: z.date({
      invalid_type_error: translationPath + "initial_date",
    }),
    endDate: z.date({ invalid_type_error: translationPath + "end_date" }),
    enable: z.boolean(),
    exception: z.boolean(),
    send: z.boolean(),
    priority: z.string().optional(),
    qtyMessageSendingAttempts: z.string().optional(),
    individualIdentifier: z.string().nullish(),
    establishments: z.array(establishmentsSchema).nullish(),
    ticketAutomationRuleEncMessageSectors: z
      .array(ticketAutomationRuleEncMessageSectorsSchema)
      .nullish(),
    ticketAutomationRuleEncMessagePrescriptionSectors: z
      .array(ticketAutomationRuleEncMessagePrescriptionSectorsSchema)
      .nullish(),
    ticketAutomationRuleEncMessageMedProcTypes: z
      .array(ticketAutomationRuleEncMessageMedProcTypesSchema)
      .nullish(),
    ticketAutomationRuleEncMessageEncounterTypes: z
      .array(ticketAutomationRuleEncMessageEncounterTypesSchema)
      .nullish(),
    ticketAutomationRuleEncMessageInProcClassifics: z
      .array(ticketAutomationRuleEncMessageInProcClassificsSchema)
      .nullish(),
  })
  .superRefine((val, ctx) => {
    if (!val.templateGeneral && !val.exception) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: translationPath + "templateGeneral",
        path: ["templateGeneral"],
      });
    }
  });

export type TAutomationRuleEncMessageForm = z.infer<
  typeof automationRuleEncMessageSchema
>;
